module.exports = __webpack_public_path__ + "static/img/chenjun.08bbddf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/people/chenjun.jpg
// module id = LeTN
// module chunks = 2